export default __webpack_public_path__ + "static/media/messText.a7cee742.svg";